import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Carriers_ds_carriers_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { full_text_search?: string, service_type_ids?: number[], ids?: number[], date_from?: string, date_to?: string, date_type?: string }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, ModifiedSysDateTime?: string, Name?: string, ScacCode?: string, ShortName?: string, Services?: { ServiceTypeId?: number, ServiceType?: { Id?: number, Name?: string, ShortName?: string } }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { full_text_search?: string, service_type_ids?: number[], ids?: number[], date_from?: string, date_to?: string, date_type?: string, $top?: number, $skip?: number, $orderby?: { column: ('Id' | 'CreatedSysDateTime' | 'ModifiedSysDateTime' | 'Name' | 'ScacCode' | 'ShortName'), order: ('asc' | 'desc') }[], $filter?: { operator: ('and' | 'or'), operands: { numberFilters?: { column: ('Id'), operation: ('equals' | 'notEqual' | 'empty' | 'lessThan' | 'lessThanOrEqual' | 'greaterThan' | 'greaterThanOrEqual'), value: number }[], numberMultiFilters?: { column: ('Id'), operation: ('in' | 'notIn'), value: number[] }[], stringFilters?: { column: ('Name' | 'ScacCode' | 'ShortName'), operation: ('equals' | 'notEqual' | 'empty' | 'contains' | 'notContains' | 'startsWith' | 'endsWith' | 'blank' | 'notBlank'), value: string }[], stringMultiFilters?: { column: ('Name' | 'ScacCode' | 'ShortName'), operation: ('in' | 'notIn'), value: string[] }[], dateFilters?: { column: ('CreatedSysDateTime' | 'ModifiedSysDateTime'), operation: ('equals' | 'notEqual' | 'empty' | 'lessThan' | 'lessThanOrEqual' | 'greaterThan' | 'greaterThanOrEqual'), value: string }[], operator: ('and' | 'or') }[] } }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, ModifiedSysDateTime?: string, Name?: string, ScacCode?: string, ShortName?: string, Services?: { ServiceTypeId?: number, ServiceType?: { Id?: number, Name?: string, ShortName?: string } }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { full_text_search?: string, service_type_ids?: number[], ids?: number[], date_from?: string, date_to?: string, date_type?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, ModifiedSysDateTime?: string, Name?: string, ScacCode?: string, ShortName?: string, Services?: { ServiceTypeId?: number, ServiceType?: { Id?: number, Name?: string, ShortName?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      full_text_search?: string, service_type_ids?: number[], ids?: number[], date_from?: string, date_to?: string, date_type?: string    }) {
      return false;
    }
}
